import { GalleryItem, GalleryItemChunks } from './getGalleryImages';

const getGalleryChunks = (images: GalleryItem[], chunksizes: number[]) => {
  const chunkArray: GalleryItemChunks[] = [];
  let cc = 0;
  let i = 0;
  let j = 0;
  while (i < images.length) {
    const csize = chunksizes[cc];
    chunkArray.push({ keyItem: `${(j += 1)}`, images: images.slice(i, i + csize) });
    cc = (cc + 1) % chunksizes.length;
    i += csize;
  }

  // Combine orphan images with the row above
  if (
    chunksizes[0] > 1 &&
    chunkArray.length > 1 &&
    chunkArray[chunkArray.length - 1].images.length === 1 &&
    chunkArray[chunkArray.length - 2].images.length === 2
  ) {
    const row = chunkArray.pop();
    if (row) chunkArray[chunkArray.length - 1].images.push(row.images[0]);
  }

  return chunkArray;
};

const getTallestHeight = (arrImages: GalleryItem[]) => {
  let tallestHeight = 0;
  for (let i = 0; i < arrImages.length; i += 1) {
    const current = arrImages[i];
    const oheight = current.height;
    if (oheight > tallestHeight) tallestHeight = oheight;
  }

  return tallestHeight;
};

const calculatePercentagesFromArrayOfImages = (arrImages: GalleryItem[], windowWidth: number) => {
  // const baselinePercentage = 100 / lengthOfArray;
  const screenWidth = windowWidth;
  const yMax = getTallestHeight(arrImages);

  // Calculate target image widths
  let imageWidthTotal = 0;
  const imageWidths: any[] = [];

  arrImages.forEach((img) => {
    const ratio = img.width / img.height;
    const w = img.width * (yMax / img.height);
    const h = w / ratio;

    imageWidthTotal += w;
    imageWidths.push({ width: w, height: h, ratio });
  });

  // Convert widths to percentages
  for (let i = 0; i < imageWidths.length; i += 1) {
    const decimalPercentValue = imageWidths[i].width / imageWidthTotal;
    const ratio = imageWidths[i].ratio;

    // 375 *  0.45 * / 1.5
    const calculatedHeight = (screenWidth * decimalPercentValue) / ratio;

    imageWidths[i] = {
      width: `${decimalPercentValue * 100}%`,
      height: Math.round(calculatedHeight),
    };
  }
  return imageWidths;
};

export { getGalleryChunks, getTallestHeight, calculatePercentagesFromArrayOfImages };
